import React, { useState } from 'react';
// import Select from 'react-select';
import ReportPdf from '../images/report.pdf';
import Select from 'react-select';
import { ReactComponent as UpArrowIcon } from '../images/Emoji.svg';
import Logo from "../images/logo.svg";
import Sidebar from '../component/Sidebar';

// const Report = () => {
  function Report() {
  const [email, setEmail] = useState("2,200.50");
  
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const options = [
    { value: 'Milions', label: 'Milions' },
    { value: 'Thousands', label: 'Thousands' },
    { value: 'Billions', label: 'Billions' }
  ]
  const colourStyles = {
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      console.log({ data, isDisabled, isFocused, isSelected });
      return {
        ...styles,
        backgroundColor: isFocused ? "#F8F8F8" : "",
        color: "#333333",
        borderBottom:1,
        borderStyle:"solid",
        borderColor:"#F2F2F2",
        fontSize:14,
        fontWeight:500,
      };
    }
  };

  const data = [
    {
      value: 1,
      text: '',
      icon: <UpArrowIcon />
    },
    {
      value: 2,
      text: '',
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down-circle" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V4.5z" />
      </svg>
    },
    {
      value: 3,
      text: '',
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left-circle" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z" />
      </svg>
    }
  ];

  const [selectedOption, setSelectedOption] = useState(null);
  
    // handle onChange event of the dropdown
    const handleChange = e => {
      setSelectedOption(e);
    }

    const defaultValue = options[0];

  return (
    <>
    <Sidebar/> 
      <div id='header'>
          <div className='logo'>
            <div className='logo_icon'>
              <img src={Logo} />
            </div>
            <div className='brand_name'>Apple Inc. <span>AAPL</span></div>
          </div>

          <div id="filter_row">
            <div className='filter_col'>
                <div className='url_col_filter'>
                  <span>Link</span>
                  <input type='text' placeholder='https//:' className='url_field' />
                </div>

                <div className='url_col_filter'>
                  <span>AR</span>
                  <input type='text' placeholder='https//:' className='url_field' />
                </div>
            </div>

            <div className='filter_col'>
                <div className='date_col_filter'>
                  <span>Date</span>
                  <div className='date_col_text'>
                    Sep 30, 2023
                  </div>
                </div>

                <div className='date_col_filter'>
                  <span>FY</span>
                  <div className='date_col_text'>
                    Annual, 2023
                  </div>
                </div>

                <div className='currency_dropdown_col_filter'>
                <Select options={options}
                styles={colourStyles}
                defaultValue={defaultValue}/>

                  {/* <select className='custom-select'>
                    <option>Milions</option>
                    <option>USD</option>
                  </select> */}
                </div>

                <div className='currency_col_filter'>
                  USD
                </div>
            </div>
          </div>

          <div className='header_monthly_value'>
            <div className='month_price_row three_year_price'>
              <div className='month_col'>
              36<span>-month</span>
              </div>
              <div className='price_white_col'>
               9,000,000,000,000,000.00 <span>USD</span>
               <span className='divider'>|</span>
               <span className='value_sortname'>9 M USD</span>
              </div>
            </div>

            <div className='month_price_row'>
              <div className='month_col'>
              24<span>-month</span>
              </div>
              <div className='price_byellow_col'>
                9,000,000,000,000,000.00 <span>USD</span>
                <span className='divider'>|</span>
               <span className='value_sortname'>9 M USD</span>
              </div>
            </div>
          </div>
      </div>
    <div className="container-fluid content pb-5">
      <div className='report_table'>
        <div className='table-responsive'>
          <table className='table table_main_report'>
              <thead>
                <tr>
                  <th className='standard_th'  data-bs-toggle="collapse" data-bs-target="#StandardsAcco">
                  <label htmlFor="Standards">Standards</label>
                  </th>
                  <th><span className='table_icon_cross'><i className="icon-cross"></i>AAOIFI</span></th>
                  <th><span className='table_icon_exlamation'><i className="icon-exclamation"></i>DJIM</span></th>
                  <th><span className='table_icon_exlamation'><i className="icon-exclamation"></i>S&P</span></th>
                  <th><span className='table_icon_cross'><i className="icon-cross"></i>FTSE</span></th>
                  <th><span className='table_icon_cross'><i className="icon-cross"></i>MSCI</span></th>
                  <th><span className='table_icon_cross'><i className="icon-cross"></i>MSCI M-series</span></th>
                  <th><span className='table_icon_cross'><i className="icon-cross"></i>SAC-SC</span></th>
                  <th><span className='table_icon_check'><i className="icon-check"></i>ISSI</span></th>
                </tr>
              </thead>
              <tbody>
              <tr>
                <td colspan="9" style={{padding:0}}>
                <div className="collapse accordion-collapse show" id="StandardsAcco" data-bs-parent=".table_main_report">
                <table width="100%" cellPadding={0} cellSpacing={0}>
                <tr className='threshold_row'>
                  <td className='left_align_td'>Threshold</td>
                  <td>30%</td>
                  <td>33%</td>
                  <td>33%</td>
                  <td>33.333%</td>
                  <td>33.33%</td>
                  <td>33.33%</td>
                  <td>33%</td>
                  <td>45%</td>
                </tr>
                <tr>
                  <td className='left_align_td'>IB assets to 36MC</td>
                  <td className='tble_green_color'>28.99%</td>
                  <td>-</td>
                  <td className='tble_green_color'>33%</td>
                  <td>-</td>
                  <td>-</td>
                  <td className='tble_green_color'>28.99%</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td className='left_align_td'>IB debt to 36MC</td>
                  <td className='tble_red_color'>101.08%</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td className='tble_red_color'>101.08%</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td className='left_align_td'>IB assets to 24MC</td>
                  <td>-</td>
                  <td className='tble_green_color'>30.52%</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td className='left_align_td'>IB assets to TA</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>                  
                  <td className='tble_green_color'>11.60%</td>
                  <td className='tble_green_color'>11.60%</td>
                  <td>-</td>
                  <td className='tble_green_color'>11.60%</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td className='left_align_td'>AR & Cash to TA</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>                  
                  <td className='tble_green_color'>33.07%</td>
                  <td className='tble_green_color'>33.07%</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td className='left_align_td'>AR & Cash to 36MC</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td> 
                  <td>-</td>
                  <td>-</td>                  
                  <td className='tble_red_color'>82.68%</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td className='left_align_td'>IB debt to TA</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td> 
                  <td className='tble_red_color'>40.43%</td>
                  <td className='tble_red_color'>40.43%</td>                  
                  <td>-</td>
                  <td className='tble_red_color'>40.43%</td>
                  <td className='tble_green_color'>40.43%</td>
                </tr>
                <tr className='threshold_row'>
                  <td className='left_align_td'>Threshold</td>
                  <td>5%</td>
                  <td>5%</td>
                  <td>5%</td> 
                  <td>5%</td>
                  <td>5%</td>                  
                  <td>-</td>
                  <td>20%</td>
                  <td>10%</td>
                </tr>
                <tr>
                  <td className='left_align_td'>Non-compliant revenue</td>
                  <td className='tble_green_color'>4.38%</td>
                  <td className='tble_green_color'>4.38%</td>
                  <td className='tble_green_color'>4.38%</td>
                  <td className='tble_green_color'>4.38%</td>
                  <td className='tble_green_color'>4.38%</td>                  
                  <td className='tble_green_color'>4.38%</td>
                  <td className='tble_green_color'>4.38%</td>
                  <td className='tble_green_color'>4.38%</td>
                </tr>
                <tr>
                  <td className='left_align_td'>Impermissible revenue</td>
                  <td className='tble_green_color'>4.01%</td>
                  <td className='tble_green_color'>4.01%</td>
                  <td className='tble_green_color'>4.01%</td>
                  <td className='tble_green_color'>4.01%</td>
                  <td className='tble_green_color'>4.01%</td>                  
                  <td className='tble_green_color'>4.01%</td>
                  <td className='tble_green_color'>4.01%</td>
                  <td className='tble_green_color'>4.01%</td>
                </tr>
                <tr>
                  <td className='left_align_td'>Doubtful revenue</td>
                  <td className='tble_lyellow_color'>8.39%</td>
                  <td className='tble_lyellow_color'>8.39%</td>
                  <td className='tble_lyellow_color'>8.39%</td>
                  <td className='tble_lyellow_color'>8.39%</td>
                  <td className='tble_lyellow_color'>8.39%</td>                  
                  <td className='tble_lyellow_color'>8.39%</td>
                  <td className='tble_lyellow_color'>8.39%</td>
                  <td className='tble_green_color'>8.39%</td>
                </tr>
                <tr>
                  <td className='left_align_td'>Compliance</td>
                  <td className='tble_red_color'>Non-Compliant</td>
                  <td className='tble_yellow_color'>DOUBTFUL</td>
                  <td className='tble_yellow_color'>DOUBTFUL</td>
                  <td className='tble_red_color'>Non-Compliant</td>
                  <td className='tble_red_color'>Non-Compliant</td>                  
                  <td className='tble_red_color'>Non-Compliant</td>
                  <td className='tble_red_color'>Non-Compliant</td>
                  <td className='tble_green_color'>Compliant</td>
                </tr>
                </table>
            </div> 
          </td>
        </tr>
              </tbody> 
          </table>
        </div>
      </div>

      <div className='row report_table_data_row'>
        <div className='col-xl-7 mt-3'>
         <div style={{borderRadius: "8 8 0 0",border: '1.011px solid #BCCDF2',}}><iframe title="Report PDF" width="100%" height="550" src={ReportPdf}></iframe></div>
        </div>

        <div className='col-xl-5 mt-3'>
          <div className='financial_table'>
            <div className='table-responsive'>
              <table className='table accordion table_accordion'>
                <thead>
                  <tr>
                    <th colSpan={3}>FINANCIAL SCREENING</th>
                  </tr>
                  <tr>
                    <td colSpan={3}>Current assets</td>
                  </tr>
                </thead>
                <tbody>                  
                  <tr className='cash_items_row'>
                    <td>Cash Items</td>
                    <td className='text_right'>94,776.80</td>
                    <td>&nbsp;</td>
                  </tr>

                  <tr className=''>
                    <td>Cash and cash equivalents</td>
                    <td className='tbl_green_col text_right'>5,684.25</td>
                    <td className='tbl_green_col'>
                    <div class="select_box select_box_red_caret">
                    <Select
                        placeholder=""
                        value={selectedOption}
                        options={data}
                        onChange={handleChange}
                        styles={colourStyles}
                        isSearchable={false}
                        getOptionLabel={e => (
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            {e.icon}
                            
                          </div>
                        )}
                      />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Restricted cash</td>
                    <td className='text_right'>6,582.30</td>
                    <td>
                    <div class="select_box select_box_red_caret">
                      <Select
                        placeholder=""
                        value={selectedOption}
                        options={data}
                        onChange={handleChange}
                        styles={colourStyles}
                        isSearchable={false}
                        getOptionLabel={e => (
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            {e.icon}
                            
                          </div>
                        )}
                      />
                      </div>
                    </td>
                  </tr>
                  <tr className=''>
                    <td className='tbl_green_col'>Current bank accounts</td>
                    <td className='text_right'>82,210.25</td>
                    <td>
                    <div class="select_box select_box_red_caret">
                      <Select
                        placeholder=""
                        value={selectedOption}
                        options={data}
                        onChange={handleChange}
                        styles={colourStyles}
                        isSearchable={false}
                        getOptionLabel={e => (
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            {e.icon}
                            
                          </div>
                        )}
                      />
                      </div>
                    </td>
                  </tr>

                  <tr className=''>
                    <td className=''>Etc.</td>
                    <td className='text_right'>300.00</td>
                    <td>
                    <div class="select_box select_box_red_caret">
                      <Select
                        placeholder=""
                        value={selectedOption}
                        options={data}
                        onChange={handleChange}
                        styles={colourStyles}
                        isSearchable={false}
                        getOptionLabel={e => (
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            {e.icon}
                            
                          </div>
                        )}
                      />
                      </div>
                    </td>
                  </tr>

                  <tr className='cash_items_row'>
                    <td className=''>Other interest-bearing assets</td>
                    <td col className='text_right'>2,200.50</td>
                    <td>&nbsp;</td>
                  </tr>

                  <tr>
                    <td>Finance lease receivables</td>
                    <td className='text_right'>80.00</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>Loans receivables</td>
                    <td className='text_right'>1,700.00</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>Bonds</td>
                    <td className='text_right'>300.00</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>Other interest-bearing securities</td>
                    <td className='text_right'>120.50</td>
                    <td>&nbsp;</td>
                  </tr>

                  <tr className='tbl_manual_row'>
                    <td>Accounts receivables</td>
                    <td className='text_right'><input type='text' value={email}  onChange={handleEmailChange}  /></td>
                    <td>&nbsp;</td>
                  </tr>

                  <tr className='tbl_current_row'>
                    <td colSpan={3}>Non-current assets</td>
                  </tr>

                  <tr className='cash_items_row'>
                    <td>Cash Items</td>
                    <td className='text_right'>94,776.80</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>Cash and cash equivalents</td>
                    <td className='text_right'>5,684.25</td>
                    <td>
                    <div class="select_box select_box_red_caret">
                      <Select
                        placeholder=""
                        value={selectedOption}
                        options={data}
                        onChange={handleChange}
                        styles={colourStyles}
                        isSearchable={false}
                        getOptionLabel={e => (
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            {e.icon}
                            
                          </div>
                        )}
                      />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Restricted cash, non-current portion</td>
                    <td className='text_right'>6,582.30</td>
                    <td>
                    <div class="select_box select_box_red_caret">
                      <Select
                        placeholder=""
                        value={selectedOption}
                        options={data}
                        onChange={handleChange}
                        styles={colourStyles}
                        isSearchable={false}
                        getOptionLabel={e => (
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            {e.icon}
                            
                          </div>
                        )}
                      />
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>Etc.</td>
                    <td className='text_right'>300.00</td>
                    <td>
                      <div class="select_box select_box_red_caret">
                        <Select
                        placeholder=""
                        value={selectedOption}
                        options={data}
                        onChange={handleChange}
                        styles={colourStyles}
                        isSearchable={false}
                        getOptionLabel={e => (
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            {e.icon}
                            
                          </div>
                        )}
                      />
                      </div>
                    </td>
                  </tr>
                  <tr className='cash_items_row'>
                    <td>Other interest-bearing assets</td>
                    <td className='text_right'>2,200.50</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>Finance lease receivables</td>
                    <td className='text_right'>80.00</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>Loans receivables</td>
                    <td className='text_right'>1,700.00</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>Other interest-bearing securities</td>
                    <td className='text_right'>120.50</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr className='tbl_manual_row'>
                    <td>Accounts receivables</td>
                    <td className='text_right'><input type='text' value={email}  onChange={handleEmailChange}  /></td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr className='tbl_manual_row'>
                    <td>AR and Cash</td>
                    <td className='text_right'><input type='text' value={email}  onChange={handleEmailChange}  /></td>
                    <td>&nbsp;</td>
                  </tr>

                  <tr className='tbl_total_assets_row'>
                    <td>TOTAL ASSETS</td>
                    <td className='text_right'>2,200.50</td>
                    <td>&nbsp;</td>
                  </tr>

                  <tr className='tbl_current_row'>
                    <td colSpan={3}>Current liabilities</td>
                  </tr>
                  <tr className='cash_items_row'>
                    <td>Interest-bearing liabilites</td>
                    <td className='text_right'>2,200.50</td>
                    <td>&nbsp;</td>
                  </tr>

                  <tr>
                    <td>Short-term debt</td>
                    <td className='text_right'>80.00</td>
                    <td>&nbsp;</td>
                  </tr>

                  <tr>
                    <td>Notes payable</td>
                    <td className='text_right'>80.00</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>Short-term finance lease payable</td>
                    <td className='text_right'>80.00</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>Other interest-bearing borrowings</td>
                    <td className='text_right'>80.00</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr className='cash_items_row'>
                    <td>Interest-bearing liabilites</td>
                    <td className='text_right'>2,200.50</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>Long-term debt</td>
                    <td className='text_right'>80.00</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>Notes payable</td>
                    <td className='text_right'>80.00</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>Finance lease payables, net of current portion</td>
                    <td className='text_right'>80.00</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr className='tbl_bas_row'>
                    <td colSpan={3}>BUSINESS ACTIVITY SCREENING</td>
                  </tr>
                  <tr className='tbl_current_row'>
                    <td colSpan={3}>Current assets</td>
                  </tr>
                  <tr className='tbl_total_assets_row'>
                    <td>TOTAL REVENUE</td>
                    <td className='text_right'>2,200.50</td>
                    <td>&nbsp;</td>
                  </tr>

                  <tr className='tbl_manual_row'>
                    <td>REVENUE FROM CORE OPERATION</td>
                    <td className='text_right'><input type='text' value={email}  onChange={handleEmailChange}  /></td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr className='tbl_accordion_row collapsed' data-bs-toggle="collapse" data-bs-target="#iPhoneAcco">
                    <td><div className='click_accordion'>iPhone</div></td>
                    <td className='text_right'>5,684.25</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td colSpan={3} style={{padding:0, border:0}}>
                      <div  className="collapse accordion-collapse" id="iPhoneAcco" data-bs-parent=".table_accordion">
                        <table width="100%">                   
                        <tr>
                            <td className='collapsed_td'>AppStore</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_green_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr> 
                        <tr>
                            <td className='collapsed_td'>Licensing</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_red_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr> 
                        <tr>
                            <td className='collapsed_td'>Apple Care and Others</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_red_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr>   
                        <tr>
                            <td className='collapsed_td'>Apple Music</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_green_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr> 
                        <tr>
                            <td className='collapsed_td'>iCloud</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_red_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr>   
                        <tr>
                            <td className='collapsed_td'>Third-party Subscriptions</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_red_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr>
                        <tr>
                            <td className='collapsed_td'>Others</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_green_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr> 
                        <tr>
                            <td className='collapsed_td'>Advertising</td>
                            <td className='text_right'>6,582.30</td>
                            <td>&nbsp;</td>
                        </tr> 
                        <tr className='tbl_manual_row'>
                            <td className='collapsed_td'>OTHER INCOME</td>
                            <td className='text_right'><input type='text' value={email}  onChange={handleEmailChange}  /></td>
                            <td>&nbsp;</td>
                        </tr>                   
                        </table>
                      </div>
                    </td>
                  </tr>
                  
                  <tr className='tbl_accordion_row collapsed' data-bs-toggle="collapse" data-bs-target="#MacAcco">
                    <td className='tbl_green_col'><div className='click_accordion'>Mac</div></td>
                    <td className='text_right'>5,684.25</td>
                    <td>
                      <div class="select_box select_box_green_caret">
                        <Select
                        placeholder=""
                        value={selectedOption}
                        options={data}
                        onChange={handleChange}
                        styles={colourStyles}
                        isSearchable={false}
                        getOptionLabel={e => (
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            {e.icon}
                            
                          </div>
                        )}
                      />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={3} style={{padding:0, border:0}}>
                      <div className="collapse accordion-collapse" id="MacAcco" data-bs-parent=".table_accordion">
                        <table width="100%">                   
                        <tr>
                            <td className='collapsed_td'>AppStore</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_green_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr> 
                        <tr>
                            <td className='collapsed_td'>Licensing</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_red_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr> 
                        <tr>
                            <td className='collapsed_td'>Apple Care and Others</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_red_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr>   
                        <tr>
                            <td className='collapsed_td'>Apple Music</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_green_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr> 
                        <tr>
                            <td className='collapsed_td'>iCloud</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_red_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr>   
                        <tr>
                            <td className='collapsed_td'>Third-party Subscriptions</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_red_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr>
                        <tr>
                            <td className='collapsed_td'>Others</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_green_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr> 
                        <tr>
                            <td className='collapsed_td'>Advertising</td>
                            <td className='text_right'>6,582.30</td>
                            <td>&nbsp;</td>
                        </tr> 
                        <tr className='tbl_manual_row'>
                            <td className='collapsed_td'>OTHER INCOME</td>
                            <td className='text_right'><input type='text' value={email}  onChange={handleEmailChange}  /></td>
                            <td>&nbsp;</td>
                        </tr>                   
                        </table>
                      </div>
                    </td>
                  </tr>

                  <tr className='tbl_accordion_row collapsed' data-bs-toggle="collapse" data-bs-target="#iPadAcco">
                    <td><div className='click_accordion'>iPad</div></td>
                    <td className='text_right'>5,684.25</td>
                    <td>
                      <div class="select_box select_box_red_caret">
                        <Select
                        placeholder=""
                        value={selectedOption}
                        options={data}
                        onChange={handleChange}
                        styles={colourStyles}
                        isSearchable={false}
                        getOptionLabel={e => (
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            {e.icon}
                            
                          </div>
                        )}
                      />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={3} style={{padding:0, border:0}}>
                      <div className="collapse accordion-collapse" id="iPadAcco" data-bs-parent=".table_accordion">
                        <table width="100%">                   
                        <tr>
                            <td className='collapsed_td'>AppStore</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_green_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr> 
                        <tr>
                            <td className='collapsed_td'>Licensing</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_red_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr> 
                        <tr>
                            <td className='collapsed_td'>Apple Care and Others</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_red_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr>   
                        <tr>
                            <td className='collapsed_td'>Apple Music</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_green_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr> 
                        <tr>
                            <td className='collapsed_td'>iCloud</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_red_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr>   
                        <tr>
                            <td className='collapsed_td'>Third-party Subscriptions</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_red_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr>
                        <tr>
                            <td className='collapsed_td'>Others</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_green_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr> 
                        <tr>
                            <td className='collapsed_td'>Advertising</td>
                            <td className='text_right'>6,582.30</td>
                            <td>&nbsp;</td>
                        </tr> 
                        <tr className='tbl_manual_row'>
                            <td className='collapsed_td'>OTHER INCOME</td>
                            <td className='text_right'><input type='text' value={email}  onChange={handleEmailChange}  /></td>
                            <td>&nbsp;</td>
                        </tr>                   
                        </table>
                      </div>
                    </td>
                  </tr>

                  <tr className='tbl_accordion_row collapsed' data-bs-toggle="collapse" data-bs-target="#WHAAcco">
                    <td><div className='click_accordion'>Wearables, Home and Accessories</div></td>
                    <td className='text_right'>5,684.25</td>
                    <td>
                      <div class="select_box select_box_green_caret">
                        <Select
                        placeholder=""
                        value={selectedOption}
                        options={data}
                        onChange={handleChange}
                        styles={colourStyles}
                        isSearchable={false}
                        getOptionLabel={e => (
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            {e.icon}
                            
                          </div>
                        )}
                      />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={3} style={{padding:0, border:0}}>
                      <div className="collapse accordion-collapse" id="WHAAcco" data-bs-parent=".table_accordion">
                        <table width="100%">                   
                        <tr>
                            <td className='collapsed_td'>AppStore</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_green_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr> 
                        <tr>
                            <td className='collapsed_td'>Licensing</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_red_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr> 
                        <tr>
                            <td className='collapsed_td'>Apple Care and Others</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_red_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr>   
                        <tr>
                            <td className='collapsed_td'>Apple Music</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_green_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr> 
                        <tr>
                            <td className='collapsed_td'>iCloud</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_red_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr>   
                        <tr>
                            <td className='collapsed_td'>Third-party Subscriptions</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_red_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr>
                        <tr>
                            <td className='collapsed_td'>Others</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_green_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr> 
                        <tr>
                            <td className='collapsed_td'>Advertising</td>
                            <td className='text_right'>6,582.30</td>
                            <td>&nbsp;</td>
                        </tr> 
                        <tr className='tbl_manual_row'>
                            <td className='collapsed_td'>OTHER INCOME</td>
                            <td className='text_right'><input type='text' value={email}  onChange={handleEmailChange}  /></td>
                            <td>&nbsp;</td>
                        </tr>                   
                        </table>
                      </div>
                    </td>
                </tr>

                  <tr className='tbl_accordion_row collapsed' data-bs-toggle="collapse" data-bs-target="#InterestIncomeAcco">
                    <td className=''><div className='click_accordion'>Interest Income</div></td>
                    <td className='text_right'>5,684.25</td>
                    <td>
                      <div class="select_box select_box_red_caret">
                        <Select
                        placeholder=""
                        value={selectedOption}
                        options={data}
                        onChange={handleChange}
                        styles={colourStyles}
                        isSearchable={false}
                        getOptionLabel={e => (
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            {e.icon}
                            
                          </div>
                        )}
                      />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={3} style={{padding:0, border:0}}>
                      <div className="collapse accordion-collapse" id="InterestIncomeAcco" data-bs-parent=".table_accordion">
                        <table width="100%">                   
                        <tr>
                            <td className='collapsed_td'>AppStore</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_green_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr> 
                        <tr>
                            <td className='collapsed_td'>Licensing</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_red_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr> 
                        <tr>
                            <td className='collapsed_td'>Apple Care and Others</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_red_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr>   
                        <tr>
                            <td className='collapsed_td'>Apple Music</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_green_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr> 
                        <tr>
                            <td className='collapsed_td'>iCloud</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_red_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr>   
                        <tr>
                            <td className='collapsed_td'>Third-party Subscriptions</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_red_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr>
                        <tr>
                            <td className='collapsed_td'>Others</td>
                            <td className='text_right'>6,582.30</td>
                            <td>
                            <div class="select_box select_box_green_caret">
                              <Select
                          placeholder=""
                          value={selectedOption}
                          options={data}
                          onChange={handleChange}
                          styles={colourStyles}
                          isSearchable={false}
                          getOptionLabel={e => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {e.icon}
                              
                            </div>
                          )}
                        />
                              </div>
                            </td>
                        </tr> 
                        <tr>
                            <td className='collapsed_td'>Advertising</td>
                            <td className='text_right'>6,582.30</td>
                            <td>&nbsp;</td>
                        </tr> 
                        <tr className='tbl_manual_row'>
                            <td className='collapsed_td'>OTHER INCOME</td>
                            <td className='text_right'><input type='text' value={email}  onChange={handleEmailChange}  /></td>
                            <td>&nbsp;</td>
                        </tr>                   
                        </table>
                      </div>
                    </td>
                  </tr>

                  <tr className='tbl_accordion_row collapsed' data-bs-toggle="collapse" data-bs-target="#OtherIncomeAcco">
                    <td className=''><div className='click_accordion'>Other Income</div></td>
                    <td className='text_right'>5,684.25</td>
                    <td>
                      <div class="select_box select_box_red_caret">
                        <Select
                        placeholder=""
                        value={selectedOption}
                        options={data}
                        onChange={handleChange}
                        styles={colourStyles}
                        isSearchable={false}
                        getOptionLabel={e => (
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            {e.icon}
                            
                          </div>
                        )}
                      />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={3} style={{padding:0, border:0}}>
                      <div className="collapse accordion-collapse" id="OtherIncomeAcco" data-bs-parent=".table_accordion">
                          <table width="100%">                   
                          <tr>
                              <td className='collapsed_td'>AppStore</td>
                              <td className='text_right'>6,582.30</td>
                              <td>
                              <div class="select_box select_box_green_caret">
                                <Select
                            placeholder=""
                            value={selectedOption}
                            options={data}
                            onChange={handleChange}
                            styles={colourStyles}
                            isSearchable={false}
                            getOptionLabel={e => (
                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                {e.icon}
                                
                              </div>
                            )}
                          />
                                </div>
                              </td>
                          </tr> 
                          <tr>
                              <td className='collapsed_td'>Licensing</td>
                              <td className='text_right'>6,582.30</td>
                              <td>
                              <div class="select_box select_box_red_caret">
                                <Select
                            placeholder=""
                            value={selectedOption}
                            options={data}
                            onChange={handleChange}
                            styles={colourStyles}
                            isSearchable={false}
                            getOptionLabel={e => (
                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                {e.icon}
                                
                              </div>
                            )}
                          />
                                </div>
                              </td>
                          </tr> 
                          <tr>
                              <td className='collapsed_td'>Apple Care and Others</td>
                              <td className='text_right'>6,582.30</td>
                              <td>
                              <div class="select_box select_box_red_caret">
                                <Select
                            placeholder=""
                            value={selectedOption}
                            options={data}
                            onChange={handleChange}
                            styles={colourStyles}
                            isSearchable={false}
                            getOptionLabel={e => (
                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                {e.icon}
                                
                              </div>
                            )}
                          />
                                </div>
                              </td>
                          </tr>   
                          <tr>
                              <td className='collapsed_td'>Apple Music</td>
                              <td className='text_right'>6,582.30</td>
                              <td>
                              <div class="select_box select_box_green_caret">
                                <Select
                            placeholder=""
                            value={selectedOption}
                            options={data}
                            onChange={handleChange}
                            styles={colourStyles}
                            isSearchable={false}
                            getOptionLabel={e => (
                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                {e.icon}
                                
                              </div>
                            )}
                          />
                                </div>
                              </td>
                          </tr> 
                          <tr>
                              <td className='collapsed_td'>iCloud</td>
                              <td className='text_right'>6,582.30</td>
                              <td>
                              <div class="select_box select_box_red_caret">
                                <Select
                            placeholder=""
                            value={selectedOption}
                            options={data}
                            onChange={handleChange}
                            styles={colourStyles}
                            isSearchable={false}
                            getOptionLabel={e => (
                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                {e.icon}
                                
                              </div>
                            )}
                          />
                                </div>
                              </td>
                          </tr>   
                          <tr>
                              <td className='collapsed_td'>Third-party Subscriptions</td>
                              <td className='text_right'>6,582.30</td>
                              <td>
                              <div class="select_box select_box_red_caret">
                                <Select
                            placeholder=""
                            value={selectedOption}
                            options={data}
                            onChange={handleChange}
                            styles={colourStyles}
                            isSearchable={false}
                            getOptionLabel={e => (
                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                {e.icon}
                                
                              </div>
                            )}
                          />
                                </div>
                              </td>
                          </tr>
                          <tr>
                              <td className='collapsed_td'>Others</td>
                              <td className='text_right'>6,582.30</td>
                              <td>
                              <div class="select_box select_box_green_caret">
                                <Select
                            placeholder=""
                            value={selectedOption}
                            options={data}
                            onChange={handleChange}
                            styles={colourStyles}
                            isSearchable={false}
                            getOptionLabel={e => (
                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                {e.icon}
                                
                              </div>
                            )}
                          />
                                </div>
                              </td>
                          </tr> 
                          <tr>
                              <td className='collapsed_td'>Advertising</td>
                              <td className='text_right'>6,582.30</td>
                              <td>&nbsp;</td>
                          </tr> 
                          <tr className='tbl_manual_row'>
                              <td className='collapsed_td'>OTHER INCOME</td>
                              <td className='text_right'><input type='text' value={email}  onChange={handleEmailChange}  /></td>
                              <td>&nbsp;</td>
                          </tr>                   
                          </table>
                        </div>
                    </td>
                  </tr>
                  
                </tbody>
              </table>
            </div>
          </div>
         
        </div>
      </div>
    </div>
    </>
  );
}

export default Report;
